import React from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import warningIcon from "../../assets/icons/warning (4).png";
import { clearInfo } from "../../utils/store/reducers/Info";

const InfoModal = () => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    dispatch(clearInfo());
  };

  const { title, msg, status } = useSelector((state) => state.info);

  React.useEffect(() => {
    setOpen(true);
    setMessage(msg);
    if (status === 500 && !msg) {
      setMessage("Internal server error. Please try again later.");
    }
  }, [title, msg, status]);
  return msg && status ? (
    <div className="info-modal-overlay">
      <div className="info-modal-container">
        <div className="info-modal-icon">
          <img src={warningIcon} alt="" />
        </div>
        <div className="info-modal-info">
          <h2 className="modal-name">{"Warning!"}</h2>
          <p className="modal-description">
            Oh no<br></br>
            {msg}
          </p>
        </div>
        <div className="info-modal-button">
          <button
            onClick={() => handleClose()}
            className="modal-button"
          >
            ok
          </button>
        </div>
      </div>
    </div>
  ) : (
    false
  );
};

export default InfoModal;
